import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OoccComponent } from "./oocc/oocc.component";
import { TablaOoccComponent } from "./oocc/components/tabla-oocc/tabla-oocc.component";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { FuseSharedModule } from "@fuse/shared.module";
import { DialogAsociarFacturaOoccComponent } from "./oocc/components/dialog-asociar-factura-oocc/dialog-asociar-factura-oocc.component";
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../shared/services/auth/role-guard.service";
import { DialogAsociarRocgesComponent } from "./oocc/components/dialog-asociar-rocges/dialog-asociar-rocges.component";
import { DialogAsociarInformeComponent } from "./oocc/components/dialog-asociar-informe/dialog-asociar-informe.component";
import { SearchboxComponent } from "./oocc/components/searchbox/searchbox.component";
import { NgxMatFileInputModule } from '@angular-material-components/file-input';

import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTableModule } from "@angular/material/table";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatListModule } from "@angular/material/list";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from "@angular/material/select";


import { DetalleOoccComponent } from "./detalle-oocc/detalle-oocc/detalle-oocc.component";
import { RecepcionOoccComponent } from "./detalle-oocc/detalle-oocc/components/recepcion-oocc/recepcion-oocc.component";
import { FacturaOoccComponent } from "./detalle-oocc/detalle-oocc/components/factura-oocc/factura-oocc.component";
import { OrdenesTrabajoOoccComponent } from "./detalle-oocc/detalle-oocc/components/ordenes-trabajo-oocc/ordenes-trabajo-oocc.component";
import { FichaOoccComponent } from "./detalle-oocc/detalle-oocc/components/ficha-oocc/ficha-oocc.component";
import { DialogReporteExcelComponent } from './oocc/components/dialog-reporte-excel/dialog-reporte-excel.component';

const routes = [
    {
        path: "ordenes-de-compra",
        component: OoccComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
    {
        path: "ordenes-de-compra/:idOOCC",
        component: DetalleOoccComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
];

@NgModule({
    declarations: [
        OoccComponent,
        TablaOoccComponent,
        DialogAsociarFacturaOoccComponent,
        DialogAsociarRocgesComponent,
        DialogAsociarInformeComponent,
        SearchboxComponent,
        DetalleOoccComponent,

        RecepcionOoccComponent,
        FacturaOoccComponent,
        OrdenesTrabajoOoccComponent,
        FichaOoccComponent,
        DialogReporteExcelComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        TranslateModule,
        FuseSharedModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatDialogModule,
        MatToolbarModule,
        MatDatepickerModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatListModule,
        NgxMatFileInputModule,
        MatSlideToggleModule,
        MatSelectModule
    ],
    exports: [TablaOoccComponent, FacturaOoccComponent],
    entryComponents: [DialogAsociarFacturaOoccComponent],
})
export class OoccModule {}
